import React, { forwardRef } from 'react';
const CarFront = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("path", { d: "M24 7.5h-2.25v.525l-.037-.037L19.124 4.5a1.918 1.918 0 0 0-1.538-.75H6.412c-.6 0-1.162.3-1.537.75L2.25 7.988l-.038.037V7.5H0v1.087h1.537l-.675.488C.337 9.525 0 10.163 0 10.838V19.5h5.25v-3h13.5v3H24v-8.662c0-.675-.338-1.35-.863-1.763l-.675-.487H24zM20.25 18v-3H3.75v3H1.5v-6h3v-1.087l-2.85-.488c.037-.038.075-.113.113-.15l1.2-.9c.187-.15.374-.338.524-.525l2.625-3.488a.453.453 0 0 1 .3-.112h11.175c.113 0 .263.075.338.15l2.625 3.487c.15.188.337.375.525.525l1.2.9a.518.518 0 0 1 .112.15l-2.887.45V12h3v6z" }),
        React.createElement("path", { d: "m6 12.188 1.837.937h8.325L18 12.187v-.937H6z" })))));
CarFront.displayName = 'CarFront';
// @ts-ignore;
const iconData = {
    glyph: CarFront,
    group: 'car',
};
export default iconData;
